<template>
    <div class="contents">
        <rotaion :height="height" :route="this.$route.path" arrow="always" position=""></rotaion>
        <div class="center">
            <!-- ---------------------------game1 -->
            <div class="blue-top"></div>
            <div class="gameinfo" ref="ssss">
                <div
                    class="game1-left"
                    :style="{
                        transform: 'translateZ(1.75px) scale(.90) translateY(' + (trans - 100) + 'px) translateX(-200px)'
                    }"
                ></div>
                <div class="text-cls">
                    <div class="text-cls-top">多元营销生态</div>
                    <div class="text-cls-bottom">丰富的营销手段，专业的增长策略，帮助各类型游戏找到适合自己的成功路径</div>
                </div>
                <div
                    class="game-right"
                    :style="{
                        transform: 'translateZ(1.75px) scale(.75) translateY(' + (trans - 300) + 'px) rotate(45deg) translateX(300px)'
                    }"
                ></div>
            </div>
            <!-- ---------------------------game2 -->
            <div class="gameinfo2">
                <div
                    class="game2-left"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + trans + 'px) rotate(-45deg) translateX(300px)'
                    }"
                ></div>
                <div class="text-cls" style="margin-left: 15rem">
                    <div class="text-cls-top">变现优化</div>
                    <div class="text-cls-bottom">深入的变现经验，用户理解，平衡用户体验和客户利益的同时，得到更好的变现效率</div>
                </div>
                <div
                    class="game2-right"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + trans + 'px) translateX(100px)'
                    }"
                ></div>
            </div>
            <!-- ---------------------------game3 -->
            <div class="gameinfo3">
                <div
                    class="game3-left"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + trans + 'px) translateX(-200px)'
                    }"
                ></div>
                <div class="text-cls" ref="aaaa">
                    <div class="text-cls-top">数据驱动思维</div>
                    <div class="text-cls-bottom">数据驱动理念，强大的数据分析工具，从立项到迭代，帮助开发者显著提高游戏项目成功率</div>
                </div>
                <div
                    class="game3-right"
                    :style="{
                        transform: 'translateZ(.25px) scale(.75) translateY(' + (trans - 300) + 'px)  rotate(45deg) translateX(400px)'
                    }"
                ></div>
            </div>
        </div>
        <div class="issue">
            <div class="issue-font">游戏发行</div>
            <div class="issue-font-bottom">
                <div class="issue-total">
                    <div class="issue-text">发行游戏数</div>
                    <div class="issue-num">300+</div>
                </div>
                <div class="issue-total" style="border-left: 1px solid #ffffff; border-right: 1px solid #ffffff">
                    <div class="issue-text">每日在线玩家</div>
                    <div class="issue-num">500万+</div>
                </div>
                <div class="issue-total">
                    <div class="issue-text">累计注册用户</div>
                    <div class="issue-num">8亿+</div>
                </div>
            </div>
            <div>
                <div class="card-video">
                    <div class="cards">
                        <div class="cards-left" style="background-image: url('https://game-cdn.feigo.fun/uploads/20211005/BV5CHB4cpev79U6ycRFfBOaOej0tHbht.png')"></div>
                        <div class="cards-right">
                            <el-image src="https://game-cdn.feigo.fun/uploads/20211005/3lZAsgbde85MecyroXFdTAwYR3ZR7py2.png" fit="cover"></el-image>
                            <span style="font-size: 20px; font-weight: 700; color: #505050">我就是天才</span>
                            <span style="font-size: 16px; color: #505050; padding: 10px; text-indent: 2em"
                                >好玩有趣，各种谜题颠覆你的想象，挑战你的脑袋，智商挑战与逆向思维的完美结合。 享受休闲游戏的同时开拓大脑，挑战自己的智力，还可以和朋友一同游玩，一起接受IQ大考验！</span
                            >
                        </div>
                    </div>
                    <div class="cards">
                        <div class="cards-left" style="background-image: url('https://game-cdn.feigo.fun/uploads/20211005/EvUFvgjynTNegsIDtrB3yrOMTVJMBV0p.png')"></div>
                        <div class="cards-right">
                            <el-image src="https://game-cdn.feigo.fun/uploads/20211005/NiefcL7rJ1RUVh9z9KOTAQrhJukhsAX2.png" fit="cover"></el-image>
                            <span style="font-size: 20px; font-weight: 700; color: #505050">我大脑最强</span>
                            <span style="font-size: 16px; color: #505050; padding: 10px; text-indent: 2em"
                                >游戏设计了数百个坑爹脑洞关卡，丰富多样，思维跳跃强，益智健脑！ 看似风平浪静的简单关卡，背后却隐藏着无数个坑
                                同样是原来的脑洞，不同关卡花样操作，手指不够灵活、脑洞不够蜂窝的小伙伴一定要好好锻炼脑力再来挑战了！</span
                            >
                        </div>
                    </div>
                </div>
                <div class="card2-video">
                    <div class="cards">
                        <div class="cards-left" style="background-image: url('https://game-cdn.feigo.fun/uploads/20201202/dmL6S4lJGsNBq1Fyr93WFP9sPrBOSInc.png')"></div>
                        <div class="cards-right">
                            <el-image src="https://game-cdn.feigo.fun/uploads/20190624/GTPLzNawnFiR1Up5v4xgeQNv2eYELlkq.png" fit="cover"></el-image>
                            <span style="font-size: 20px; font-weight: 700; color: #505050">王者搭桥</span>
                            <span style="font-size: 16px; color: #505050; padding: 10px; text-indent: 2em">长按伸长你的如意板，搭桥解救小宠物；千万级注册用户。</span>
                        </div>
                    </div>
                    <div class="cards">
                        <div class="cards-left" style="background-image: url('https://game-cdn.feigo.fun/uploads/20211005/ge4dkGohdJC4oiU3d4K26CiyaABZMq7e.png')"></div>
                        <div class="cards-right">
                            <el-image src="https://game-cdn.feigo.fun/uploads/20211005/Aum1PRDuvrqKHeSE59rR3s3W5S9e1nwa.png" fit="cover"></el-image>
                            <span style="font-size: 20px; font-weight: 700; color: #505050">成语考功名</span>
                            <span style="font-size: 16px; color: #505050; padding: 10px; text-indent: 2em">全民级别休闲小游戏，本游戏寓教于乐，快来动动脑筋，猜猜成语，还能预防老年痴呆哦。</span>
                        </div>
                    </div>
                </div>
                <div class="more-btn">
                    <button class="more-game" @click="goList()">更多游戏</button>
                </div>
            </div>
        </div>

        <div class="dynamic">
            <div class="dynamic-top-text">品牌动态</div>
            <div class="dynamic-cards">
                <div class="dynamics-card" v-for="(item, index) in dynamic" :key="index">
                    <div class="dynamic-image" :style="{ 'background-image': 'url(' + item.image + ')' }"></div>
                    <div class="dynamicn-game-text">
                        <div class="dynamicn-name">{{ item.name }}</div>
                        <div class="dynamic-text">{{ item.content }}</div>
                    </div>
                </div>
            </div>
            <div class="more-dynamic">
                <button class="more-dynamic-btn" @click="goList()">更多动态</button>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>

<script>
import rotaion from './components/rotation';
import bottom from './components/bottom';
export default {
    components: { rotaion, bottom },
    data() {
        return {
            height: window.innerHeight,
            trans: 100,
            trans2: 0,
            i: 0,
            dynamic: [
                {
                    image: 'https://game-cdn.feigo.fun/uploads/20201202/zMHOEg26v3dCKogCyP1rTaSP1et1iQM5.png',
                    name: '《超级坦克王》：',
                    content:
                        '超级坦克王是一款酷炫的坦克题材游戏，双方轮流开炮，生命条消耗完的一方失败，游戏里有各种技能不同的坦克，左手控制坦克移动，右手瞄准发射炮弹，精美的卡通游戏画风，酷炫的技能特效，再加上音效和震动配合，玩起来体验极好。'
                },
                {
                    image: 'https://game-cdn.feigo.fun/uploads/20201202/jDszvAbFwiVHE69FRr4U39H5HEceVBLF.png',
                    name: '《天梯跑酷》：',
                    content: '酷酷的小机甲，在楼顶凭梯纵跃，看谁才是玩伸缩梯的真正高手。'
                },
                {
                    image: 'https://game-cdn.feigo.fun/uploads/20201202/PE9vQVPNnezIdr2nDaCdIlXYyGdQA3hs.png',
                    name: '《竞速车神》：',
                    content:
                        '竞速车神是一款超级刺激、解压的卡丁车竞速游戏，玩家控制着在赛车，在海滨公路上极速狂飙；更是可超控导弹技能对敌人的战车进行狂轰滥炸，同时利用护盾技能拦截敌人的火炮，勇夺第一，快来一起体验极速竞技的快感，释放你的无限激情！'
                }
            ]
        };
    },
    methods: {
        handleScroll(event) {
            let top = this.$refs.ssss.getBoundingClientRect().top;
            let top2 = this.$refs.aaaa.getBoundingClientRect().top;
            var scrollTop = window.pageYOffset;
            var scroll = scrollTop - this.i;
            this.i = scrollTop;
            if (-this.height < top < this.height) {
                if (scroll < 0) {
                    this.trans = top / 5 + 200;
                } else {
                    this.trans = top / 5 + 200;
                }
            }
        },
        goList() {
            this.$router.push('/productList');
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
};
</script>

<style  src="./css/home.css" >
</style>
